module.exports = __webpack_public_path__ + "static/media/36.9b45f771.jpg";